// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
              url(https://images.pexels.com/photos/8143944/pexels-photo-8143944.jpeg);
  background-size: cover;
  background-position: center;
  color: white;
  padding: 100px 20px 80px;
  text-align: center;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.hero-content p {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
  font-weight: 300;
}

.hero-section1 {
  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
              url(https://images.pexels.com/photos/6436752/pexels-photo-6436752.jpeg);
  background-size: cover;
  background-position: center;
  color: white;
  padding: 100px 20px 80px;
  text-align: center;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content1 h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.hero-content1 p {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
  font-weight: 300;
}

/* Services Grid */
.services-grid {
  background-color: #f8f9fa;
  padding: 80px 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.services-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.service-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  transition: transform 0.3s ease;
}

.service-card:hover .service-icon {
  transform: scale(1.05);
}

.service-card h3 {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #2d3748;
}

.service-card p {
  color: #718096;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 25px;
}

.service-button {
   background: black;
  border: 2px solid var(--white);
  color: var(--white);
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.service-button:hover {
  color: #000000;
  background: white;
  border: 1px solid black;
}

.service-button .arrow {
  transition: transform 0.3s ease;
  font-size: 1.2rem;
}

.service-button:hover .arrow {
  transform: translateX(5px);
}

/* Bottom CTA Section */
.bottom-cta {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  color: white;
  padding: 60px 20px;
}

.cta-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
}

.cta-text h2 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.cta-text p {
  font-size: 1.1rem;
  opacity: 0.8;
}

.cta-button {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  white-space: nowrap;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(229, 62, 62, 0.4);
}

.cta-button .arrow {
  transition: transform 0.3s ease;
  font-size: 1.2rem;
}

.cta-button:hover .arrow {
  transform: translateX(5px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2.2rem;
  }
  
  .hero-content p {
    font-size: 1.1rem;
  }

  .hero-content1 h1 {
    font-size: 2.2rem;
  }
  
  .hero-content1 p {
    font-size: 1.1rem;
  }
  
  .services-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .service-card {
    padding: 30px 20px;
  }
  
  .cta-content {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  
  .cta-text h2 {
    font-size: 1.6rem;
  }
  
  .bottom-cta {
    padding: 50px 20px;
  }
}

@media (max-width: 480px) {
  .hero-section {
    padding: 60px 15px 50px;
    min-height: 300px;
  }
  
  .hero-content h1 {
    font-size: 1.8rem;
  }
  
  .hero-content p {
    font-size: 1rem;
  }
  
  .services-grid {
    padding: 50px 15px;
  }
  
  .services-cards {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .service-card {
    padding: 25px 15px;
  }
  
  .service-card h3 {
    font-size: 1.2rem;
  }
  
  .service-card p {
    font-size: 0.9rem;
  }
  
  .bottom-cta {
    padding: 40px 15px;
  }
  
  .cta-text h2 {
    font-size: 1.4rem;
  }
  
  .cta-text p {
    font-size: 1rem;
  }
  
  .cta-button {
    padding: 14px 24px;
    font-size: 1rem;
  }
}

/* Pentru ecrane foarte mari */
@media (min-width: 1400px) {
  .services-cards {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .container {
    max-width: 1400px;
  }
}
.furniture-hero {
  background: #f8f6f3;
  padding: 3rem 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.hero-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6rem;
  align-items: center;
  min-height: 80vh;
}

/* Left Side - Text Section */
.hero-text-section {
  max-width: 500px;
  padding-right: 2rem;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 300;
  color: #2c2c2c;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.hero-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-weight: 400;
}

.hero-details {
  font-size: 0.95rem;
  color: #777;
  line-height: 1.6;
  font-weight: 400;
}

/* Right Side - Image with Overlaid Features */
.hero-image-section {
  position: relative;
  width: 100%;
}

.kitchen-image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  position: relative;
}

.kitchen-interior {
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #f5f2ed 0%, #e8e2d8 50%, #d4c8b8 100%);
}

.kitchen-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 30% 30%, rgba(139, 111, 71, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(100, 80, 60, 0.1) 0%, transparent 50%),
    linear-gradient(45deg, rgba(200, 180, 150, 0.1) 0%, rgba(160, 140, 120, 0.05) 100%);
}

.kitchen-elements {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

/* Kitchen Elements */
.cabinet-upper {
  position: absolute;
  top: 60px;
  right: 40px;
  width: 240px;
  height: 100px;
  background: linear-gradient(135deg, #8b6f47 0%, #a0845a 100%);
  border-radius: 6px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.cabinet-upper::before {
  content: '';
  position: absolute;
  top: 25px;
  left: 15px;
  right: 15px;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.cabinet-upper::after {
  content: '';
  position: absolute;
  top: 50px;
  left: 15px;
  right: 15px;
  height: 2px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1px;
}

.cabinet-lower {
  position: absolute;
  bottom: 180px;
  right: 40px;
  width: 240px;
  height: 140px;
  background: linear-gradient(135deg, #6b5637 0%, #8b6f47 100%);
  border-radius: 6px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.island {
  position: absolute;
  bottom: 200px;
  left: 45%;
  transform: translateX(-50%);
  width: 200px;
  height: 70px;
  background: linear-gradient(135deg, #f0ede8 0%, #d4c8b8 100%);
  border-radius: 8px;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
}

.island::after {
  content: '';
  position: absolute;
  top: -20px;
  left: 8px;
  right: 8px;
  height: 12px;
  background: linear-gradient(135deg, #c8b89d 0%, #b5a48e 100%);
  border-radius: 6px;
}

.dining-area {
  position: absolute;
  bottom: 40px;
  left: 40px;
  width: 280px;
  height: 240px;
}

.table {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 90px;
  background: linear-gradient(135deg, #4a3f35 0%, #5c4f42 100%);
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.table::before {
  content: '';
  position: absolute;
  top: -8px;
  left: -15px;
  right: -15px;
  height: 16px;
  background: linear-gradient(135deg, #6b5a4a 0%, #7d6b5a 100%);
  border-radius: 10px;
}

.chairs {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 160px;
}

.chair {
  position: absolute;
  width: 38px;
  height: 70px;
  background: linear-gradient(135deg, #3a3330 0%, #4a3f3c 100%);
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.chair:nth-child(1) {
  bottom: 100px;
  left: 30px;
  transform: rotate(-12deg);
}

.chair:nth-child(2) {
  bottom: 95px;
  left: 95px;
  transform: rotate(8deg);
}

.chair:nth-child(3) {
  bottom: 100px;
  right: 95px;
  transform: rotate(-6deg);
}

.chair:nth-child(4) {
  bottom: 105px;
  right: 30px;
  transform: rotate(10deg);
}

.chair::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 3px;
  right: 3px;
  height: 30px;
  background: linear-gradient(135deg, #4a3f3c 0%, #5a4d47 100%);
  border-radius: 5px 5px 3px 3px;
}

/* Features Overlay - Positioned over the image */
.features-overlay {
  position: absolute;
  top: 20px;
  left: -100px;
  width: 320px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.feature-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  width: 28px;
  height: 28px;
  color: #8b6f47;
  margin-bottom: 0.75rem;
}

.feature-icon svg {
  width: 100%;
  height: 100%;
}

.feature-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c2c2c;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
}

.feature-description {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .hero-container {
    gap: 4rem;
  }

  .features-overlay {
    left: -80px;
    width: 300px;
  }

  .hero-title {
    font-size: 2.2rem;
  }
}

@media (max-width: 968px) {
  .hero-container {
    grid-template-columns: 1fr;
    gap: 2rem; /* redus pentru încadrare */
    text-align: left;
    padding: 0 1rem; /* margini interne */
  }

  .hero-text-section {
    margin-top: 140px;
    max-width: 100%;
    padding-right: 0;
    order: 2;
  }

  .hero-image-section {
    order: 1;
    height: auto;
    max-height: 50vh; /* încadrat pe jumătate de ecran */
  }

  .features-overlay {
    position: relative;
    top: 1rem;
    left: 0;
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    display: grid;
    gap: 1rem;
  }

  .feature-card {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .furniture-hero {
    padding: 1rem 0; /* redus */
    min-height: 100vh; /* încadrat în ecran */
    box-sizing: border-box;
  }

  .hero-container {
    padding: 0 1rem;
    gap: 2rem;
  }

  .hero-title {
    font-size: 1.9rem;
  }

  .hero-description {
    font-size: 1rem;
  }

  .hero-image-section {
    height: auto;
    max-height: 45vh;
  }

  .features-overlay {
    grid-template-columns: 1fr;
    top: 1rem;
  }

  .feature-card {
    padding: 1.25rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    margin-top: 185px;
    font-size: 1.6rem;
    line-height: 1.3;
  }

  .hero-description,
  .hero-details {
    font-size: 0.9rem;
  }

  .feature-title {
    font-size: 1rem;
  }

  .feature-description {
    font-size: 0.85rem;
  }

  .hero-image-section {
    height: auto;
    max-height: 40vh;
  }

  .feature-card {
    padding: 1rem;
  }
}


.hero-image-section img {
  width: 100%;
  height: auto; /* păstrează proporțiile */
  display: block;
}

@media (max-width: 768px) {
  .hero-image-section img {
    display: flex;
    margin: auto;
    justify-content: center;
    max-width: 100%; /* pe mobil, imaginea ocupă tot spațiul containerului */
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Servicii.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;qFACmF;EACnF,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;qFACmF;EACnF,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;GACG,iBAAiB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;uFAGqF;AACvF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS,EAAE,2BAA2B;IACtC,gBAAgB;IAChB,eAAe,EAAE,oBAAoB;EACvC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,gBAAgB,EAAE,kCAAkC;EACtD;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,2DAA2D;IAC3D,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe,EAAE,UAAU;IAC3B,iBAAiB,EAAE,sBAAsB;IACzC,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,WAAW;EACX,YAAY,EAAE,0BAA0B;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,eAAe,EAAE,uDAAuD;EAC1E;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.app {\n  font-family: 'Arial', sans-serif;\n  line-height: 1.6;\n}\n\n/* Hero Section */\n.hero-section {\n  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),\n              url(https://images.pexels.com/photos/8143944/pexels-photo-8143944.jpeg);\n  background-size: cover;\n  background-position: center;\n  color: white;\n  padding: 100px 20px 80px;\n  text-align: center;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero-content h1 {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  letter-spacing: -0.02em;\n}\n\n.hero-content p {\n  font-size: 1.2rem;\n  opacity: 0.9;\n  max-width: 800px;\n  margin: 0 auto;\n  font-weight: 300;\n}\n\n.hero-section1 {\n  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),\n              url(https://images.pexels.com/photos/6436752/pexels-photo-6436752.jpeg);\n  background-size: cover;\n  background-position: center;\n  color: white;\n  padding: 100px 20px 80px;\n  text-align: center;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero-content1 h1 {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  letter-spacing: -0.02em;\n}\n\n.hero-content1 p {\n  font-size: 1.2rem;\n  opacity: 0.9;\n  max-width: 800px;\n  margin: 0 auto;\n  font-weight: 300;\n}\n\n/* Services Grid */\n.services-grid {\n  background-color: #f8f9fa;\n  padding: 80px 20px;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.services-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 30px;\n}\n\n.service-card {\n  background: white;\n  border-radius: 16px;\n  padding: 40px 30px;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n}\n\n.service-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 25px;\n  transition: transform 0.3s ease;\n}\n\n.service-card:hover .service-icon {\n  transform: scale(1.05);\n}\n\n.service-card h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: #2d3748;\n}\n\n.service-card p {\n  color: #718096;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 25px;\n}\n\n.service-button {\n   background: black;\n  border: 2px solid var(--white);\n  color: var(--white);\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.service-button:hover {\n  color: #000000;\n  background: white;\n  border: 1px solid black;\n}\n\n.service-button .arrow {\n  transition: transform 0.3s ease;\n  font-size: 1.2rem;\n}\n\n.service-button:hover .arrow {\n  transform: translateX(5px);\n}\n\n/* Bottom CTA Section */\n.bottom-cta {\n  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);\n  color: white;\n  padding: 60px 20px;\n}\n\n.cta-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 40px;\n}\n\n.cta-text h2 {\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.cta-text p {\n  font-size: 1.1rem;\n  opacity: 0.8;\n}\n\n.cta-button {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n  color: white;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  white-space: nowrap;\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(229, 62, 62, 0.4);\n}\n\n.cta-button .arrow {\n  transition: transform 0.3s ease;\n  font-size: 1.2rem;\n}\n\n.cta-button:hover .arrow {\n  transform: translateX(5px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-content h1 {\n    font-size: 2.2rem;\n  }\n  \n  .hero-content p {\n    font-size: 1.1rem;\n  }\n\n  .hero-content1 h1 {\n    font-size: 2.2rem;\n  }\n  \n  .hero-content1 p {\n    font-size: 1.1rem;\n  }\n  \n  .services-cards {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .service-card {\n    padding: 30px 20px;\n  }\n  \n  .cta-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 30px;\n  }\n  \n  .cta-text h2 {\n    font-size: 1.6rem;\n  }\n  \n  .bottom-cta {\n    padding: 50px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-section {\n    padding: 60px 15px 50px;\n    min-height: 300px;\n  }\n  \n  .hero-content h1 {\n    font-size: 1.8rem;\n  }\n  \n  .hero-content p {\n    font-size: 1rem;\n  }\n  \n  .services-grid {\n    padding: 50px 15px;\n  }\n  \n  .services-cards {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n  \n  .service-card {\n    padding: 25px 15px;\n  }\n  \n  .service-card h3 {\n    font-size: 1.2rem;\n  }\n  \n  .service-card p {\n    font-size: 0.9rem;\n  }\n  \n  .bottom-cta {\n    padding: 40px 15px;\n  }\n  \n  .cta-text h2 {\n    font-size: 1.4rem;\n  }\n  \n  .cta-text p {\n    font-size: 1rem;\n  }\n  \n  .cta-button {\n    padding: 14px 24px;\n    font-size: 1rem;\n  }\n}\n\n/* Pentru ecrane foarte mari */\n@media (min-width: 1400px) {\n  .services-cards {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .container {\n    max-width: 1400px;\n  }\n}\n.furniture-hero {\n  background: #f8f6f3;\n  padding: 3rem 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.hero-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6rem;\n  align-items: center;\n  min-height: 80vh;\n}\n\n/* Left Side - Text Section */\n.hero-text-section {\n  max-width: 500px;\n  padding-right: 2rem;\n}\n\n.hero-title {\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: #2c2c2c;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  color: #666;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  font-weight: 400;\n}\n\n.hero-details {\n  font-size: 0.95rem;\n  color: #777;\n  line-height: 1.6;\n  font-weight: 400;\n}\n\n/* Right Side - Image with Overlaid Features */\n.hero-image-section {\n  position: relative;\n  width: 100%;\n}\n\n.kitchen-image {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.kitchen-interior {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: linear-gradient(135deg, #f5f2ed 0%, #e8e2d8 50%, #d4c8b8 100%);\n}\n\n.kitchen-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 30% 30%, rgba(139, 111, 71, 0.15) 0%, transparent 50%),\n    radial-gradient(circle at 70% 70%, rgba(100, 80, 60, 0.1) 0%, transparent 50%),\n    linear-gradient(45deg, rgba(200, 180, 150, 0.1) 0%, rgba(160, 140, 120, 0.05) 100%);\n}\n\n.kitchen-elements {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n/* Kitchen Elements */\n.cabinet-upper {\n  position: absolute;\n  top: 60px;\n  right: 40px;\n  width: 240px;\n  height: 100px;\n  background: linear-gradient(135deg, #8b6f47 0%, #a0845a 100%);\n  border-radius: 6px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n.cabinet-upper::before {\n  content: '';\n  position: absolute;\n  top: 25px;\n  left: 15px;\n  right: 15px;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.cabinet-upper::after {\n  content: '';\n  position: absolute;\n  top: 50px;\n  left: 15px;\n  right: 15px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 1px;\n}\n\n.cabinet-lower {\n  position: absolute;\n  bottom: 180px;\n  right: 40px;\n  width: 240px;\n  height: 140px;\n  background: linear-gradient(135deg, #6b5637 0%, #8b6f47 100%);\n  border-radius: 6px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n.island {\n  position: absolute;\n  bottom: 200px;\n  left: 45%;\n  transform: translateX(-50%);\n  width: 200px;\n  height: 70px;\n  background: linear-gradient(135deg, #f0ede8 0%, #d4c8b8 100%);\n  border-radius: 8px;\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);\n}\n\n.island::after {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: 8px;\n  right: 8px;\n  height: 12px;\n  background: linear-gradient(135deg, #c8b89d 0%, #b5a48e 100%);\n  border-radius: 6px;\n}\n\n.dining-area {\n  position: absolute;\n  bottom: 40px;\n  left: 40px;\n  width: 280px;\n  height: 240px;\n}\n\n.table {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 140px;\n  height: 90px;\n  background: linear-gradient(135deg, #4a3f35 0%, #5c4f42 100%);\n  border-radius: 8px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.table::before {\n  content: '';\n  position: absolute;\n  top: -8px;\n  left: -15px;\n  right: -15px;\n  height: 16px;\n  background: linear-gradient(135deg, #6b5a4a 0%, #7d6b5a 100%);\n  border-radius: 10px;\n}\n\n.chairs {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 160px;\n}\n\n.chair {\n  position: absolute;\n  width: 38px;\n  height: 70px;\n  background: linear-gradient(135deg, #3a3330 0%, #4a3f3c 100%);\n  border-radius: 5px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.chair:nth-child(1) {\n  bottom: 100px;\n  left: 30px;\n  transform: rotate(-12deg);\n}\n\n.chair:nth-child(2) {\n  bottom: 95px;\n  left: 95px;\n  transform: rotate(8deg);\n}\n\n.chair:nth-child(3) {\n  bottom: 100px;\n  right: 95px;\n  transform: rotate(-6deg);\n}\n\n.chair:nth-child(4) {\n  bottom: 105px;\n  right: 30px;\n  transform: rotate(10deg);\n}\n\n.chair::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 3px;\n  right: 3px;\n  height: 30px;\n  background: linear-gradient(135deg, #4a3f3c 0%, #5a4d47 100%);\n  border-radius: 5px 5px 3px 3px;\n}\n\n/* Features Overlay - Positioned over the image */\n.features-overlay {\n  position: absolute;\n  top: 20px;\n  left: -100px;\n  width: 320px;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.feature-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.feature-icon {\n  width: 28px;\n  height: 28px;\n  color: #8b6f47;\n  margin-bottom: 0.75rem;\n}\n\n.feature-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.feature-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #2c2c2c;\n  margin: 0 0 0.5rem 0;\n  line-height: 1.3;\n}\n\n.feature-description {\n  font-size: 0.9rem;\n  color: #666;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .hero-container {\n    gap: 4rem;\n  }\n\n  .features-overlay {\n    left: -80px;\n    width: 300px;\n  }\n\n  .hero-title {\n    font-size: 2.2rem;\n  }\n}\n\n@media (max-width: 968px) {\n  .hero-container {\n    grid-template-columns: 1fr;\n    gap: 2rem; /* redus pentru încadrare */\n    text-align: left;\n    padding: 0 1rem; /* margini interne */\n  }\n\n  .hero-text-section {\n    margin-top: 140px;\n    max-width: 100%;\n    padding-right: 0;\n    order: 2;\n  }\n\n  .hero-image-section {\n    order: 1;\n    height: auto;\n    max-height: 50vh; /* încadrat pe jumătate de ecran */\n  }\n\n  .features-overlay {\n    position: relative;\n    top: 1rem;\n    left: 0;\n    width: 100%;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    display: grid;\n    gap: 1rem;\n  }\n\n  .feature-card {\n    margin: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .furniture-hero {\n    padding: 1rem 0; /* redus */\n    min-height: 100vh; /* încadrat în ecran */\n    box-sizing: border-box;\n  }\n\n  .hero-container {\n    padding: 0 1rem;\n    gap: 2rem;\n  }\n\n  .hero-title {\n    font-size: 1.9rem;\n  }\n\n  .hero-description {\n    font-size: 1rem;\n  }\n\n  .hero-image-section {\n    height: auto;\n    max-height: 45vh;\n  }\n\n  .features-overlay {\n    grid-template-columns: 1fr;\n    top: 1rem;\n  }\n\n  .feature-card {\n    padding: 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    margin-top: 185px;\n    font-size: 1.6rem;\n    line-height: 1.3;\n  }\n\n  .hero-description,\n  .hero-details {\n    font-size: 0.9rem;\n  }\n\n  .feature-title {\n    font-size: 1rem;\n  }\n\n  .feature-description {\n    font-size: 0.85rem;\n  }\n\n  .hero-image-section {\n    height: auto;\n    max-height: 40vh;\n  }\n\n  .feature-card {\n    padding: 1rem;\n  }\n}\n\n\n.hero-image-section img {\n  width: 100%;\n  height: auto; /* păstrează proporțiile */\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .hero-image-section img {\n    display: flex;\n    margin: auto;\n    justify-content: center;\n    max-width: 100%; /* pe mobil, imaginea ocupă tot spațiul containerului */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
